export type IconName =
  | "pen"
  | "eraser"
  | "fill"
  | "picker"
  | "line"
  | "rectangle"
  | "ellipse"
  | "hand"
  | "undo"
  | "redo"
  | "more"
  | "expand"
  | "close"
  | "minus"
  | "plus";
const paths: Record<IconName, string> = {
  pen: "m15 4 5 5M4 20l5-1L20 8a2 2 0 0 0-5-5L4 14z",
  eraser: "m14 4 6 6a2 2 0 0 1 0 3l-7 7H7l-4-4a2 2 0 0 1 0-3l8-9a2 2 0 0 1 3 0ZM7 9l8 8M13 20h8",
  fill: "m4 11 8-8 8 8-8 8-8-8Zm0 0h16M9 2l5 5M20 16c-3 3-3 5 0 5s3-2 0-5Z",
  picker: "m14 4 6 6M16 2l6 6M18 6 5 19l-3 3 1-5L16 4",
  line: "M4 20 20 4",
  rectangle: "M4 5h16v14H4z",
  ellipse: "M21 12a9 8 0 1 1-18 0 9 8 0 1 1 18 0",
  hand: "M8 12V6a2 2 0 0 1 4 0v5-7a2 2 0 0 1 4 0v8-5a2 2 0 0 1 4 0v8c0 5-3 7-7 7-3 0-5-2-7-5l-3-4c-1-2 1-4 3-2l2 2",
  undo: "M8 4 3 9l5 5M3 9h11a6 6 0 0 1 0 12",
  redo: "m16 4 5 5-5 5M21 9H10a6 6 0 0 0 0 12",
  more: "M4 12h1m6 0h1m6 0h1",
  expand: "M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5",
  close: "m6 6 12 12M18 6 6 18",
  minus: "M5 12h14",
  plus: "M5 12h14M12 5v14",
};
export function Icon({ name }: { name: IconName }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}
